import type { Components, Theme } from '@mui/material/styles'

import { borderWidth, spacing } from '@/themes/tokens'

// Extend Paper with the form-surface variant, matching untool-mage.
declare module '@mui/material/Paper' {
  interface PaperPropsVariantOverrides {
    form: true
  }
}

export const MuiPaperOverride: Components<Theme>['MuiPaper'] = {
  defaultProps: {
    variant: 'elevation',
    elevation: 0
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(spacing.lg),
      borderRadius: theme.spacing(spacing.md)
    }),
    outlined: ({ theme }) => ({
      border: `${borderWidth.thin}px solid ${theme.palette.divider}`
    })
  },
  variants: [
    {
      // The surface a form sits on. Same padding, radius, shadow and border as
      // untool-mage's `form` variant, minus its `alignItems: center` and
      // `minWidth` — those centre and shrink children, which would collapse this
      // form's full-width inputs. Width is already bounded by the page Container.
      props: { variant: 'form' },
      style: ({ theme }) => ({
        padding: theme.spacing(spacing.xl),
        borderRadius: 12,
        boxShadow: theme.shadows[1],
        border: `${borderWidth.thin}px solid ${theme.palette.divider}`
      })
    }
  ]
}
